import React, { Component } from 'react'
import intl from 'react-intl-universal'
// import { NavLink } from 'react-router-dom'
import NavLink from '../components/LinkHack'
import shortid from 'shortid'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment-timezone'
import ReviewsReview from './ReviewsReview'
import { observer } from 'mobx-react/index'
import { action, observable } from 'mobx'

@observer
class Reviews extends Component {
  @observable showReviewsModal = false

  @action toggleReviewsModal = (event) => {
    event.preventDefault()

    if (!this.showReviewsModal) {
      this.showReviewsModal = true
      document.body.classList.add('js-modal-opened')
    } else {
      this.showReviewsModal = false
      document.body.classList.remove('js-modal-opened')
    }
  }

  render () {
    const { reviews } = this.props

    return (
      <div className='b-reviews'>
        {reviews.slice(0, 3).map((review, index) =>
          <ReviewsReview
            key={shortid.generate()}
            review={review}
          />
        )}
        {this.showReviewsModal &&
        <div className='b-modal-wrap'>
          <div className='b-modal'>
            <div className='b-modal-header b-modal-header_border'>
              {intl.get('Reviews')}
              <button className='b-button-close'
                      onClick={this.toggleReviewsModal}
              />
            </div>
            <div className='b-modal-content'>
              {reviews.slice(0, 3).map((review, index) =>
                <ReviewsReview
                  key={shortid.generate()}
                  review={review}
                />
              )}
            </div>
          </div>
        </div>}
        {reviews.length > 3 &&
        <button className='b-link'
                type='button'
                onClick={this.toggleReviewsModal}>{intl.get('experiences.see_all_reviews')}</button>}
      </div>
    )
  }
}

Reviews.propTypes = {
  reviews: PropTypes.any,
}

export default Reviews



// WEBPACK FOOTER //
// ./src/components/Reviews.js